import React, { useEffect, useState } from 'react'
import { PlusOutlined, SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button, Input, Modal, Select, Tag, message } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { fetchGroupList } from '../../apis/group'
import { SearchWrapper } from '../DataSource/dataSource.styled'
import useParams from '../../hook/useParams'
import { WhiteWrapper } from './group.styled'
import MainTable from '../../components/Basic/MainTable'
import dayjs from 'dayjs'
import { deleteRole, fetchRoleList } from '../../apis/role'
import RoleModal from './modals/RoleModal'
import { fetchFunctions } from '../../apis/auth'

function RoleList (props) {
  const { adminMode } = props
  const { t: ln_t } = useTranslation()
  const user = useSelector((state) => state.user)
  const params = useParams({}, false)
  const { handleFetchParams, fetchParams, setReady } = params
  const userGroupOptions = user?.groups?.map(i => ({ value: i.id, label: i.name })) || []

  const [groupsOption, setGroupsOption] = useState(userGroupOptions)
  const [allPermissionMenu, setAllPermissionMenu] = useState()
  const [showModal, setShowModal] = useState(false)
  const [modalData, setModalData] = useState({})

  const handleAdd = () => {
    setModalData({ addMode: true })
    setShowModal(true)
  }
  const handleEdit = record => {
    setModalData(record)
    setShowModal(true)
  }

  const handleDelete = record => {
    Modal.confirm({
      title: `${ln_t('util.delete')} ${ln_t('group.role')}`,
      content: `${ln_t('message.confirm.delete')} ${record.name}?`,
      onOk: async () => {
        const result = await deleteRole(record?.id)
        if (result?.status === 204) {
          handleFetchParams('add', {})
          message.success(ln_t('message.success.delete'))
        }
      }
    })
  }

  const apiFunc = async () => fetchRoleList(fetchParams)
  const formatDate = (data, detail) => dayjs(data).format(`YYYY-MM-DD${detail ? ' hh:mm:ss' : ''}`)
  const columns = [
    { title: ln_t('group.name'), dataIndex: 'name' },
    { title: ln_t('group.permission'), dataIndex: 'functions', sorter: true, render: e => e?.map(({ id, name }) => <Tag key={id}>{name}</Tag>) },
    { title: ln_t('group.status'), dataIndex: 'status', sorter: true, render: e => e ? ln_t('util.enable') : ln_t('util.disable') },
    { title: ln_t('util.createdAt'), dataIndex: 'createdAt', sorter: true, render: e => formatDate(e) },
    { title: ln_t('util.updatedAt'), dataIndex: 'updatedAt', sorter: true, render: e => formatDate(e, true) },
    {
      title: ln_t('util.action'),
      dataIndex: 'id',
      render: (id, record) => <div className="action-btn">
        <Button size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
        <Button size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(record)} />
      </div>
    }
  ]

  const successCallback = () => {
    message.success(ln_t('message.success.create'))
    handleFetchParams('add', {})
  }

  const getGroups = async () => {
    const result = await fetchGroupList({ maxResults: 1000, sort: '-updatedAt' })
    if (result?.status === 200) setGroupsOption(result?.data.map(i => ({ value: i.id, label: i.name, functions: i.functions })))
  }
  const getFunctions = async () => {
    const result = await fetchFunctions({ maxResults: 1000, status: 1, type: 1 })
    if (result?.status === 200) setAllPermissionMenu(result?.data)
  }
  useEffect(() => {
    getFunctions()
    if (adminMode) {
      getGroups()
      return setReady(true)
    }
    handleFetchParams('add', { groupId: user?.nowGroup })
    setReady(true)
  }, [])

  return (
    <WhiteWrapper>
      <h3>{ln_t('group.role')}</h3>
      <SearchWrapper>
        <div style={{ display: 'flex' }}>
          <Input.Search
            allowClear
            style={{ width: '400px' }}
            placeholder={ln_t('util.search')}
            onSearch={e => handleFetchParams('add', { name_like: `%${e}%` })}
            enterButton={<Button type="primary" size="small" icon={<SearchOutlined />} />}
          />
          {adminMode
            ? <div className="d-flex">
                <div style={{ fontSize: '14px', fontWeight: 500, margin: 'auto 8px' }}>{ln_t('util.group')} :</div>
                <Select
                  showSearch
                  style={{ minWidth: '120px' }}
                  defaultValue="all"
                  placeholder={`${ln_t('util.select')} ${ln_t('util.group')}`}
                  options={[{ value: 'all', label: 'ALL' }, ...groupsOption]}
                  optionFilterProp="children"
                  onChange={e => handleFetchParams('add', { groupId: e === 'all' ? undefined : e })}
                />
              </div>
            : ''}
        </div>
        <Button type="default" icon={<PlusOutlined />} onClick={() => handleAdd()}>
          {ln_t('util.add')} {ln_t('group.role')}
        </Button>
      </SearchWrapper>
      <MainTable
        columns={columns}
        rowKey="id"
        apiFunc={apiFunc}
        params={params}
      />
      <RoleModal
        show={showModal}
        setShow={setShowModal}
        data={modalData}
        adminMode={adminMode}
        successCallback={successCallback}
        allPermissionMenu={allPermissionMenu}
        groupsOption={groupsOption}
      />
    </WhiteWrapper>
  )
}

export default RoleList
